/**
 * Utility functions for Persona identity verification
 */

import { PERSONA_STATUS } from "shared/config/constants/integrations.constants";

/**
 * Checks if Persona status indicates the verification is incomplete (not started or in progress)
 * @param personaStatus - The Persona status string (e.g., "NOT_STARTED", "IN_PROGRESS", "COMPLETED", "FAILED")
 * @returns true if the status indicates incomplete verification, false otherwise
 */
export const isPersonaIncomplete = (personaStatus?: string | null): boolean => {
  if (!personaStatus) return false;
  return (
    personaStatus === PERSONA_STATUS.PENDING ||
    personaStatus === PERSONA_STATUS.IN_PROGRESS
  );
};
